console.log('1.5');
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer,SuperClusterAlgorithm } from "@googlemaps/markerclusterer";
import focus from "@alpinejs/focus";
import mask from "@alpinejs/mask";
window.Alpine = Alpine
Alpine.plugin(intersect);
Alpine.plugin(mask);
Alpine.plugin(focus);
//var cdn_url='https://parsec.test';
var cdn_url='https://vvv4.myhomein.com';
if(document.getElementById("cdn_url").href){ cdn_url=document.getElementById("cdn_url").href; cdn_url=cdn_url.replace(/\/$/, ''); }
window.cdn_url=cdn_url;

var cdn_url_img='https://vvv4.myhomein.com';
if(document.getElementById("cdn_url_img").href){ cdn_url_img=document.getElementById("cdn_url_img").href; cdn_url_img=cdn_url_img.replace(/\/$/, ''); }
window.cdn_url_img=cdn_url_img;
/////////////////////////////////////////////
// LIVEWIRE EXPIRE
Livewire.onPageExpired((response, message) => {
    location.reload();
});

/////////////////////////////////////////////
// PROPERTY CARROUSEL
Alpine.data("listing_carrousel", (property_id, first_image, default_image) => ({
    property_id:property_id,
    default_image:default_image,
    first_image:first_image,
    lazy_images:[],
    images_to_render:[],
    images:[],
    images_count:0,
    currentIndex: 1,
    index:0,
    image:null,
    lazy_init(){
        this.images_to_render=[];
        //this.images_to_render[0]=this.default_image;
        this.images_count=1;
        if(this.first_image!=null){
            this.images_to_render[0]='/'+this.first_image;
            this.images_count=1;
        }
    },
    intersect_init(){
        const url = new URL(cdn_url_img+"/api/property/"+property_id+"/images");
        const params = { "sort": "order", };
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        fetch(url, {  method: "GET", })
        .then((response) => response.json())
        .then((data) => {

            var lazy_images_data=(data.data);
            var temp_images=[];
            for(var i=0;i<lazy_images_data.length;i++){
                var cdn=lazy_images_data[i].cdn;
                var variations=lazy_images_data[i].variations??false;
                if(!variations){ continue; }
                temp_images[i]={'1x':cdn+''+variations['listing_1x']};
                if(variations['listing_2x']??false){ temp_images[i]['2x']=cdn+''+variations['listing_2x']; }
                if(variations['listing_1x_webp']??false){ temp_images[i]['1x_webp']=cdn+''+variations['listing_1x_webp']; }
                if(variations['listing_2x_webp']??false){ temp_images[i]['2x_webp']=cdn+''+variations['listing_2x_webp']; }
            }
            if(temp_images.length>0){
                this.lazy_images=temp_images;
                this.images_to_render=[this.lazy_images[0], this.lazy_images[1]];
                this.images_count=this.lazy_images.length;
            }
        });
    },
    previous() {
        if (this.currentIndex > 1) {
           // this.set_images_to_render();
            this.currentIndex = this.currentIndex - 1;
        }
    },
    forward() {
        if (this.currentIndex < this.images_count) {
            this.images_to_render[this.currentIndex]=this.lazy_images[this.currentIndex];
            if(this.lazy_images[this.currentIndex+1]){ this.images_to_render[this.currentIndex+1]=this.lazy_images[this.currentIndex+1]; }
            this.currentIndex = this.currentIndex + 1;
        }
    },
}));

/////////////////////////////////////////////
// PROPERTY CARROUSEL
Alpine.data("listing_carrousel_3", (property_id, first_image, default_image) => ({
    property_id:property_id,
    default_image:default_image,
    first_image:first_image,
    lazy_images:[],
    images_to_render:[],
    images:[],
    images_count:0,
    currentIndex: 1,
    index:0,
    image:null,
    lazy_init(){
        this.images_to_render=[];
        //this.images_to_render[0]=this.default_image;
        this.images_count=1;
        if(this.first_image!=null){
            this.images_to_render[0]='/'+this.first_image;
            this.images_count=1;
        }
    },
    intersect_init(){
        const url = new URL(cdn_url_img+"/api/property/"+property_id+"/images");
        const params = { "sort": "order", };
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        fetch(url, {  method: "GET", })
        .then((response) => response.json())
        .then((data) => {

            var lazy_images_data=(data.data);
            var temp_images=[];
            for(var i=0;i<lazy_images_data.length;i++){
                var cdn=lazy_images_data[i].cdn;
                var variations=lazy_images_data[i].variations??false;
                if(!variations){ continue; }
                temp_images[i]={'1x':cdn+''+variations['listing_1x']};
                if(variations['listing_2x']??false){ temp_images[i]['2x']=cdn+''+variations['listing_2x']; }
                if(variations['listing_1x_webp']??false){ temp_images[i]['1x_webp']=cdn+''+variations['listing_1x_webp']; }
                if(variations['listing_2x_webp']??false){ temp_images[i]['2x_webp']=cdn+''+variations['listing_2x_webp']; }
            }
            if(temp_images.length>0){
                this.lazy_images=temp_images;
                this.images_to_render=[this.lazy_images[0], this.lazy_images[1]];
                this.images_count=this.lazy_images.length;
            }
        });
    },
}));

Alpine.data("counter", (min, max,value) => ({
    value:value,
    min: min,
    max: max,
    init() {
        if(this.value==null && this.$refs.input.value){ this.value=this.$refs.input.value; }
        this.value=this.value??0;
        this.insert();
    },
    add(value) {
        this.value = parseInt(this.value) + value;
        this.insert();
    },
    remove(value) {
        this.value = this.value - value;
        this.insert();
    },
    insert() {
        if (this.value < this.min) {
            this.value = this.min;
        }
        if (this.value > this.max) {
            this.value = this.max;
        }
        this.$refs.input.value = this.value??0;
    },
}));


//////////////////////////////////////////////
// REPEAT LIST
Alpine.data("repeatList", (datas, newDataModel, moreparams) => ({
    newDataModel: newDataModel ?? [],
    datas: datas ?? [],
    init() {  console.log(this.datas); },
    addRow() {
        console.log('addRow');
        this.datas.push(JSON.parse(JSON.stringify(this.newDataModel)));
        this.$dispatch("change-repeat-list");
    },
    addRowAfter(index) {
        this.datas.splice(
            index + 1,
            0,
            JSON.parse(JSON.stringify(this.newDataModel))
        );
        this.$dispatch("change-repeat-list");
    },
    upRow(index) {
        if (index - 1 >= 0) {
            this.swapPositions(this.datas, index, index - 1);
            this.$dispatch("change-repeat-list");
        }
    },
    downRow(index) {
        if (index + 1 < this.datas.length) {
            this.swapPositions(this.datas, index, index + 1);
            this.$dispatch("change-repeat-list");
        }
    },
    swapPositions(array, a, b) {
        [array[a], array[b]] = [array[b], array[a]];
    },
    deleteRow(index) {
        console.log()
        this.datas = this.datas.filter((data, dataIndex) => {
            return index !== dataIndex;
        });
        this.$dispatch("change-repeat-list");
    },
}));

window.formatter = new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  });

/////////////////////////////////////////////
// PHONE INPUT
Alpine.data("phoneinput", (iti, linked) => ({
    init_lazy: function () {
        var fake_input=this.$el.querySelector('.phone_fake_input');
        var real_input=this.$el.querySelector('.phone_real_input');

        if (fake_input && !fake_input.hasAttribute("inited")) {
            import("intl-tel-input").then((loader2) => {
                import("intl-tel-input/build/css/intlTelInput.css").then(
                    (loader2css) => {
                        window.intlTelInput2 = loader2.default;
                        linked = real_input;
                        fake_input.value=linked.value;
                        fake_input.setAttribute("inited", "true");
                        iti = window.intlTelInput2(fake_input, {
                            //    separateDialCode: true,
                            initialCountry: "FR",
                            nationalMode: true,
                            preferredCountries: ["FR", "DE", "GB"],
                            utilsScript: "/vendor/intl-tel-input/build/js/utils.js",
                           // hiddenInput: name_input,
                           customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
                            return "Téléphone";
                            },

                        });
                        fake_input.addEventListener( "change", this.update_real_input );
                        fake_input.addEventListener( "keyup", this.update_real_input );
                        fake_input.addEventListener( "countrychange", this.update_real_input);
                    }
                );
            });
        }
    },
    update_real_input: function () {
        linked.value = iti.getNumber();
        linked.dispatchEvent(new Event("input"));
    },
}));


/////////////////////////////////////////////
// IMAGES PROPETIES
Alpine.data("galeryMultipleUpload", (images,wire) => ({
    images:images,
    wire:wire,
    modal_open:false,
    loaded:false,
    selected_image:false,
    isFocused: false,
    rotateAngle:false,
    progress: 0,
    description:[],
    init() {
        let thisval=this;
        this.$watch("images", (value) => {
            if(this.modal_open){
                this.images=value;
                this.selected_image=this.selectImagebyId(this.selected_image.id);
            }
        });
        import('sortablejs').then((Sortable2) => {
            var Sortable = (window.Sortable = Sortable2.default);
            this.sortable = Sortable.create(thisval.$refs.list,{
                chosenClass: "opacity-30",
                onEnd: function (/**Event*/evt) {
                    var order = thisval.sortable.toArray();
                    thisval.wire.imageUpdateOrder(order)
                }
            });
        });
        const lang = ['fr', 'en', 'de','it','es'];
        lang.forEach($element =>
            this.$watch('description.'+$element , value => this.updateDescription($element ,value))
        );
    },
    updateDescription(lang='fr',description=null){
        this.wire.set('images.'+(this.selected_image.id)+'.description.'+lang,description);
    },
    selectImagebyId(id) {
        let r=false;
        this.rotateAngle=0;
        Object.entries(this.images).forEach(([key, el_data]) => {
            if(el_data.id==id){
                r=(el_data);
                if(el_data.modification && el_data.modification.rotate){ this.rotateAngle=el_data.modification.rotate; }
            }
        });
        return r;
    },
    rotateSelectedImage(){
        this.loaded=false;
        this.selected_image;
        this.rotateAngle=this.rotateAngle-90;
        if(this.rotateAngle<=-360){ this.rotateAngle=0; }
        this.wire.imageRotate(this.selected_image.id, this.rotateAngle);
    },
    toggleDeleteSelectedImage(){
        this.wire.toggleImageDelete(this.selected_image.id);
        this.close();
    },
    goTo(index) {

        this.modal_open=true;
        this.img_url=null;
        this.loaded=false;
        this.selected_image=this.selectImagebyId(index);
        const lang = ['fr', 'en', 'de','it','es'];
        lang.forEach($element =>
            this.description[$element]=(typeof this.selected_image.description !=="undefined"?(this.selected_image.description[$element]??null):null)
        );
    },
    close(){
        this.selected_image=false;
        this.modal_open=false;
        this.img_url=null;
        this.loaded=false;
    },
    handleFiles() {
        console.log('galeryMultipleUpload');
        this.wire.uploadMultiple('new_images', this.$refs.input.files, () => {
        }, () => {
        }, (event) => {
            this.progress = event.detail.progress || 0
        });
    }
}));



/////////////////////////////////////////////
// PAGINATION SCROLL
window.livewire.on('pagination', () => {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
});
window.livewire.on('scrollOnTop', () => {
    setTimeout(function(){
        console.log('scrollOnTop');
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    },100)

});

/////////////////////////////////////////////
// GMAP
var map_s=null;
var markerClusterer=null;
var markers_on_map=[];
var move_initied_by_user=false;
var opened_info_window=null;
Alpine.data("search_gmap2", (gmap_visible,url_map_request, selected_map_property, params={}) => ({
    gmap_visible:gmap_visible,
    url_map_request:url_map_request,
    auto_update_map:false,
    selected_map_property:false,
    ovr_map:null,
    lock_controls:false,
    container_map_height:0, container_map_top:0,
    properties_coordinates:[],
    moved_position:false,
    infoWindow:null,
    lazy_init_map() {
        console.log('lazy_init_map');
        var _this=this;
        this.$watch('url_map_request', function(value){
            console.log('updated url_map_request');
            _this.delete_markers();
            _this.get_ajax_result();
        });
        if(!this.inited){ this.inited=true;
            let _this=this;
            this.set_container_height();
                const loader = new Loader({apiKey: "AIzaSyBXFZ-hats5tTbrD6qGE81TEZY-B70dunc" ,libraries: ["marker"] });
                // Request needed libraries.
                loader.load().then(async () => {
                    const { Map, InfoWindow } = await google.maps.importLibrary("maps");
                    const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary(
                    "marker",
                    );
                    _this.init_map();
            });
        }
    },
    get_ajax_result() {
        // SHOW #h1_loading
        document.getElementById('h1_loading').style.display='block';
        var _this=this;
        _this.properties_coordinates=[];
        _this.lock_controls=true;
        fetch('/s-get-gps-coordinates?'+this.url_map_request).then((res) => res.json())
        .then((data) => {
            console.log('get_ajax_result : '+'/s-get-gps-coordinates?'+this.url_map_request);
            _this.properties_coordinates=data;
            _this.draw_markers();

        });
    },
    init_map() {
        console.log('init_map');
        var map = new google.maps.Map(this.$refs.map_search, {
            center: {lat: 46.603629, lng: 2.5184350},
            zoom: 3,
            mapId: "DEMO_MAP_ID",
            disableDoubleClickZoom: true,
            streetViewControl: false, disableDefaultUI: true, scrollwheel: false, zoomControl: false, maxZoom : 22, mapTypeId : google.maps.MapTypeId.ROADMAP, gestureHandling: 'greedy',clickableIcons: false
        });

        this.infoWindow = new google.maps.InfoWindow({
            content: "",
            disableAutoPan: true,
        });

        map_s=map;
        var _this=this;
        this.get_ajax_result();


        var btn_zoom_in=document.getElementById('map_zoom_in');
        var btn_zoom_out=document.getElementById('map_zoom_out');
        btn_zoom_in.addEventListener('click', (e) => {
            _this.moved_position=true;
            e.preventDefault();
            e.stopPropagation();
            if(_this.lock_controls){ return false; }
            console.log('btn_zoom_in '+(map_s.getZoom()));
            map_s.setZoom(map_s.getZoom() + 1);

            if(map_s.getZoom()>=8){ _this.auto_update_map=true; }
            move_initied_by_user=true;
            _this.auto_refresh();
        });
        btn_zoom_out.addEventListener('click', (e) => {
            console.log('btn_zoom_out '+(map_s.getZoom() - 1));
            e.preventDefault();
            e.stopPropagation();
            _this.moved_position=true;
            if(_this.lock_controls){ return false; }
            map_s.setZoom(map_s.getZoom() - 1);
            if(map_s.getZoom()<8){ _this.auto_update_map=false; }
            move_initied_by_user=true;
            _this.auto_refresh();
        });

        map_s.addListener('dragend', function() {
            move_initied_by_user=true;
            _this.moved_position=true;
            if(this.lock_controls){ return false; }
            _this.auto_refresh();
        });
    },
    auto_refresh(){
        console.log('auto_refresh');

        var bounds = map_s.getBounds();

        // Obtenir les coins nord-est et sud-ouest du viewport
        var NE = bounds.getNorthEast();
        var SW = bounds.getSouthWest();
        if(this.auto_update_map){
            this.ovr_map={'ne_lat':NE.lat(),'ne_lng':NE.lng(),'sw_lat':SW.lat(),'sw_lng':SW.lng()};
        }

    },
    refresh_by_user(){
        console.log('refresh_by_user');
        this.moved_position=false;
        var bounds = map_s.getBounds();

        // Obtenir les coins nord-est et sud-ouest du viewport
        var NE = bounds.getNorthEast();
        var SW = bounds.getSouthWest();

        this.ovr_map={'ne_lat':NE.lat(),'ne_lng':NE.lng(),'sw_lat':SW.lat(),'sw_lng':SW.lng()};

        this.get_ajax_result();
    },
    delete_markers_n_clusters(){
        this.delete_markers();
        this.delete_clusters();
    },
    delete_markers(){
        for (var ii = 0; ii <= markers_on_map.length; ii++) {
            if(markers_on_map[ii]){
                markers_on_map[ii].setMap(null);
            }
        }
        markers_on_map=[];
    },
    delete_clusters(){
        if (markerClusterer) {
            console.log('Deleting markerClusterer');
            markerClusterer.clearMarkers();
            markerClusterer= null;
        }
    },
    draw_markers(){
        var map=map_s;
        let properties_coordinates=this.properties_coordinates;
        // DELETE MARKERS
        this.delete_markers_n_clusters(); // Effacer les clusters existants



        markers_on_map=properties_coordinates.map((data, i) => {
            return this.draw_marker(data);
        });
        if(markers_on_map.length!=0 && !move_initied_by_user){
            // SET NEW BOUNDS
            var map_bounds=this.get_bounds();
            map_s.panToBounds(map_bounds);
            map_s.fitBounds(map_bounds);
            if(map_s.getZoom()>=8){ this.auto_update_map=true; }else{ this.auto_update_map=false; }
        }
        move_initied_by_user=false;

        const imagePath = "https://cdn.myhomein.fr/img/logo/marker_cluster_2.svg";
        let renderer = {
        render: ({ count, position }) =>
            new google.maps.Marker({
                label: { text: String(count), color: "#fc5c63", fontSize: "13px" },
                position,
                icon: {  url: imagePath, scaledSize: new google.maps.Size(40, 40), },
                // adjust zIndex to be above other markers
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
            }),
        };

        // if(pan){
        //     this.map_s.panToBounds(map_bounds);
        //     this.map_s.fitBounds(map_bounds);
        // }

      // WRITE IN #h1_counter THE NUMBER OF PROPERTIES
        document.getElementById('h1_counter').innerHTML=properties_coordinates.length;
        // HIDE #h1_loading
        document.getElementById('h1_loading').style.display='none';
        // SHOW #h1
        document.getElementById('h1').style.display='block';
        // IF ZOOM > 8 THAN DON'T SHOW CLUSTER
        if(map_s.getZoom()<=14){
            var mcOptions = {gridSize: 40, maxZoom: 14, zoomOnClick: false, minimumClusterSize: 50,onClusterClick:false};
            markerClusterer= new MarkerClusterer({ markers: markers_on_map, map: map, renderer: renderer,
                algorithm: new SuperClusterAlgorithm(mcOptions)
           }); //  , onClusterClick : function(cluster){ console.log(cluster); }
        }
        else{
            markerClusterer= null;
            markers_on_map.forEach((marker) => {
                marker.setMap(map);
            });
        }
        this.lock_controls=false;

    },
    get_bounds(){
        var map_bounds = new google.maps.LatLngBounds();
        // DRAW MARKERS
        for (var i = 0; i < markers_on_map.length; i++) {
            let point = new google.maps.LatLng(parseFloat(markers_on_map[i].position.lat), parseFloat(markers_on_map[i].position.lng));
            map_bounds.extend(point)
        }
        return map_bounds;
    },
    draw_marker(data){

            let position = {lat: parseFloat(data.lat), lng: parseFloat(data.lng)};
            const parser = new DOMParser();
            const pinSvgString =
            '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#232e5e"><g stroke-width="1.5"><path stroke="#232e5e" d="M17 10.193c0 2.867-4.5 8.307-5 8.307s-5-5.44-5-8.307C7 7.325 9.239 5 12 5s5 2.325 5 5.193z"/><circle cx="12" cy="10" r="2" stroke="#fc5c63" fill="#fc5c63"/></g></svg>';
            let pinSvg = parser.parseFromString( pinSvgString, "image/svg+xml",).documentElement;

            const pinGlyph = new google.maps.marker.PinElement({
                glyph: 'sdfsd',
                glyphColor: "white",
            });


            const marker = new google.maps.marker.AdvancedMarkerElement({
                position,
                content: pinSvg,
                //icon:{ url: cdn_url_img+"/img/svg/marker.svg" , scale: 4   }
            });
        var _this=this;

        marker.addListener("click", () => {
            if(opened_info_window){ opened_info_window.close(); opened_info_window=null; }
            // GET CONTENT HTML
            fetch('/s-map-block?property_id='+data.id).then((res) => res.text()).then((data) => {

                this.infoWindow.setContent(data);
                this.infoWindow.open(map, marker);
                opened_info_window=this.infoWindow;
                console.log(opened_info_window);
                 // DECALAGE
                 var scale = Math.pow(2, map_s.getZoom());
                 var worldCoordinateCenter = map_s.getProjection().fromLatLngToPoint(position);
                 var pixelOffset = new google.maps.Point((0/scale) || 0,(-250/scale) ||0);
                 var worldCoordinateNewCenter = new google.maps.Point(
                     worldCoordinateCenter.x - pixelOffset.x,
                     worldCoordinateCenter.y + pixelOffset.y
                 );
                 var newCenter = map_s.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
                 map_s.panTo(newCenter);
            });
        });
        return marker;
    },
    set_container_height(){
        //this.$refs.filter_container.offsetHeight+this.$refs.filter_container.getBoundingClientRect().top
        this.container_map_height = (window.innerHeight-(document.getElementById('filter_container').offsetHeight+160+ window.scrollY));
        // this.container_map_top=this.$refs.filter_container.offsetHeight;
    },
}));


document.addEventListener('livewire:load', function () {
    // Listen to the event when the redirect is triggered
    Livewire.on('triggerRedirect', () => {
        // Show the loader
        document.getElementById('loader_reservation_form').style.display = 'block';
    });
});


Alpine.data("search_gmap", (params={}) => ({
    gmap_visible:false,
    map_s:null, inited:false,
    properties_cards:[],
    markers_on_map:[],
    activated_markers_on_map:null,
    container_map_height:0, container_map_top:0,
    moved_position:false,
    auto_update_map:true,
    ovr_map:null,
    lazy_init_map() {

        if(!this.inited){ this.inited=true;
            let thisval=this;
            this.set_container_height();
            import("@googlemaps/js-api-loader").then((gmap) => {
                const loader = new gmap.Loader({apiKey: "AIzaSyBXFZ-hats5tTbrD6qGE81TEZY-B70dunc"/* ,libraries: ["drawing"] */});
                loader.load().then(function () {
                    thisval.init_map();
                });
            });
            Livewire.on('listUpdatedProperties', (params) => {   thisval.draw_markers();   })
            Livewire.on('modelUpdatedProperties', (params) => { setTimeout(function(){  thisval.draw_markers();  },2000)  })
        }
       //Livewire.on('updateMapSearch', (params) => { console.log('updateMapSearch');  this.draw_markers();  })
    },
    get_properties_cards_data(){
        let thisval=this;
        thisval.properties_cards=[];
        if(!this.$refs.result_list){ return false; }
        var properties_cards = this.$refs.result_list.querySelectorAll(".card-property");
        properties_cards.forEach(function(item){
            var id=item.dataset.propertyId??false;
            var lat=item.dataset.lat??false;
            var lng=item.dataset.lng??false;
            var price=item.dataset.price??false;
            if(!id || !lat || !lng || !price){ return false; }

            thisval.properties_cards.push({'id':id, 'lat':lat,'lng':lng,'price':price});
        });
    },
    draw_markers(pan=false){
        // DELETE OLDS
        for (var ii = 0; ii <= this.markers_on_map.length; ii++) {
            if(this.markers_on_map[ii]){
                this.markers_on_map[ii].setMap(null);
            }
        }
        this.markers_on_map=[];
        // GET PROPERTIES
        this.get_properties_cards_data();
        if(this.properties_cards.length!=0){
            // SET NEW BOUNDS
            var map_bounds = new google.maps.LatLngBounds();
            // DRAW MARKERS
            for (var i = 0; i < this.properties_cards.length; i++) {
                this.markers_on_map.push(this.draw_marker(this.properties_cards[i]));
                let point = new google.maps.LatLng(parseFloat(this.properties_cards[i].lat), parseFloat(this.properties_cards[i].lng));
                map_bounds.extend(point)
            }
            // BOUNDS
            if(!this.auto_update_map){
                this.map_s.panToBounds(map_bounds);
                this.map_s.fitBounds(map_bounds);
            }
        }
        if(pan){
            this.map_s.panToBounds(map_bounds);
            this.map_s.fitBounds(map_bounds);
        }

    },
    draw_marker(data){
        var customMarker = new this.map_s.customMarker({lat: parseFloat(data.lat), lng: parseFloat(data.lng)},data.id,data.price  , this.map_s);
        customMarker.setMap(this.map_s);
        return customMarker;

    },
    init_map() {

        var map_s = new google.maps.Map(this.$refs.map_search, {
            center: {lat: 46.603629, lng: 2.5184350},
            zoom: 6, disableDoubleClickZoom: true,
            streetViewControl: false, disableDefaultUI: true, scrollwheel: false, zoomControl: false, maxZoom : 16, mapTypeId : google.maps.MapTypeId.ROADMAP, gestureHandling: 'greedy',clickableIcons: false
        });
        // CLOSE ACTIVATED
        map_s.addListener("click", () => {
            // DEACTIVATE ACTIVATED
            if(thisval.activated_markers_on_map){ thisval.activated_markers_on_map.deactivate();  }
        });
        this.inited=false;
        let thisval=this;
        // BTNS (ZOOM IN/OUT)
        var btn_zoom_in=document.getElementById('map_zoom_in');
        var btn_zoom_out=document.getElementById('map_zoom_out');
        btn_zoom_in.addEventListener('click', (e) => {
            console.log('btn_zoom_in '+(map_s.getZoom() + 1));
            e.preventDefault();
            e.stopPropagation();
            map_s.setZoom(map_s.getZoom() + 1);
            thisval.moved_position=true;
            thisval.auto_refresh();
        });
        btn_zoom_out.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            map_s.setZoom(map_s.getZoom() - 1);
            thisval.moved_position=true;
            thisval.auto_refresh();
        });
        map_s.addListener('dragend', function() {
            thisval.moved_position=true;
            thisval.auto_refresh();
        });
        // CUSTOM MARKER
        map_s.customMarker = class CustomMarker extends google.maps.OverlayView {
            constructor(position, property_id, price, map) {
                super();
                this.position = position;
                this.property_id = property_id;
                this.price = price;
                this.activated = false;
                this.property_card = null;
                this.map_s = map_s;
            }
            onAdd() {
                // Créez l'élément HTML qui sera affiché sur la carte
                this.property_card=thisval.$refs.result_list.querySelectorAll('.card-property[data-property-id="'+this.property_id+'"]')[0];
                this.div = document.createElement('div');
                this.div.classList.add('marker');
                this.div.style.position = 'absolute'
                this.div.innerHTML = '<span class="marker-price">'+this.price+'€</span>';
                // Ajoutez l'élément HTML à la carte
                this.getPanes().overlayImage.appendChild(this.div)
                // HOVER
                this.property_card.addEventListener('mouseover', (e) => {
                    this.map_s.panTo(this.position);  this.hover();
                    // DEACTIVATE ACTIVATED
                    if(thisval.activated_markers_on_map){
                        thisval.activated_markers_on_map.deactivate();
                    }
                });
                this.property_card.addEventListener('mouseleave', (e) => {   this.out(); });
                this.div.addEventListener('mouseover', (e) => {   this.hover(); });
                this.div.addEventListener('mouseleave', (e) => {   this.out(); });
                this.div.addEventListener('click', (e) => {
                    if($(e.target).parents('.card').length == 0){
                         e.preventDefault(); e.stopPropagation();  this.activate();
                        }
                });
            }
            draw() {
                // Mettez à jour la position de l'élément HTML sur la carte
                var point = this.getProjection().fromLatLngToDivPixel(this.position);
                let up_position=point.x-100;
                this.div.style.left = point.x + 'px';
                this.div.style.top = point.y + 'px';
            }
            onRemove() {
                // Supprimez l'élément HTML de la carte
                this.div.parentNode.removeChild(this.div);
                this.div = null;
                delete this;
            }
            hover () {
                if (this.div !== null) {
                    this.div.classList.add('hovered');
                    this.property_card.classList.add('hovered-property-card');
                }
                //$('.properties-listing-container [data-property-id="'+this.property_id+'"]').addClass('hovered-in-map');
            }
            out () {
                if (this.div !== null) {
                    this.div.classList.remove('hovered');
                    this.property_card.classList.remove('hovered-property-card');
                }
            }
            activate () {



                // DEACTIVATE ACTIVATED
                if(!this.activated){
                    if(thisval.activated_markers_on_map && thisval.activated_markers_on_map!=this){
                        thisval.activated_markers_on_map.deactivate();
                    }
                }
                console.log('activate');
                // THEN ADD NEW
                if (this.div !== null && !this.activated ) {
                    thisval.activated_markers_on_map=this;
                    this.activated=true;
                    this.div.classList.add('is-expanded');
                    var width=this.property_card.offsetWidth;
                    var cloned = this.property_card.cloneNode(true);
                    cloned.classList.remove('selected-property-card');
                    cloned.style.width='300px';
                    // SLIDESHOW
                    var slideshows=cloned.querySelectorAll('.listing-carrousel-inner');
                    slideshows.forEach($element =>
                        $element.parentNode.removeChild($element)
                    );
                    this.div.appendChild(cloned);
                    // DECALAGE
                    var scale = Math.pow(2, this.map_s.getZoom());
                    var worldCoordinateCenter = this.map_s.getProjection().fromLatLngToPoint(this.position);
                    var pixelOffset = new google.maps.Point((0/scale) || 0,(-100/scale) ||0);
                    var worldCoordinateNewCenter = new google.maps.Point(
                        worldCoordinateCenter.x - pixelOffset.x,
                        worldCoordinateCenter.y + pixelOffset.y
                    );
                    var newCenter = this.map_s.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
                    this.map_s.panTo(newCenter);
                }
            }
            deactivate () {
                if (this.div !== null && this.activated) {
                    this.activated=false;
                    thisval.activated_markers_on_map=null;
                    this.div.innerHTML = '<span class="marker-price">'+this.price+'€</span>';
                    this.div.classList.remove('is-expanded')
                }
            }
        }
        this.map_s=map_s;
        this.draw_markers();

    },
    set_container_height(){
        // this.container_map_height = (window.innerHeight-(this.$refs.filter_container.offsetHeight+this.$refs.filter_container.getBoundingClientRect().top + window.scrollY));
        // this.container_map_top=this.$refs.filter_container.offsetHeight;
    },
    auto_refresh(){
        if(this.auto_update_map && this.moved_position){
            this.refresh_by_user();
        }
    },
    refresh_by_user(){
        this.moved_position=false;
        console.log("refresh_by_user");
        var bounds = this.map_s.getBounds();

        // Obtenir les coins nord-est et sud-ouest du viewport
        var NE = bounds.getNorthEast();
        var SW = bounds.getSouthWest();

        this.ovr_map={'ne_lat':NE.lat(),'ne_lng':NE.lng(),'sw_lat':SW.lat(),'sw_lng':SW.lng()};
        // var bounds = this.map_s.getBounds();
        // var center = bounds.getCenter();
        // var ne = bounds.getNorthEast();
        // var r = 3963.0;
        // var lat1 = center.lat() / 57.2958;
        // var lon1 = center.lng() / 57.2958;
        // var lat2 = ne.lat() / 57.2958;
        // var lon2 = ne.lng() / 57.2958;
        // var dis = r * Math.acos(Math.sin(lat1) * Math.sin(lat2) + Math.cos(lat1) * Math.cos(lat2) * Math.cos(lon2 - lon1));
        //
    }
}));



//////////////////////////////////////////////
// DESTINATION INPUT
Alpine.data("input_proposition", (selected_item,urlAjax,lang,site_id) => ({
    search:null,
    open:false,
    site_id:site_id,
    lang:lang,
    urlAjax:urlAjax,
    selected_item:selected_item,
    sourceData:[],
    init(){
        var _this=this;
        this.$watch('site_id', function(value){
            _this.selected_item=[];
            _this.search=null;
        });
        this.$watch('selected_item', function(value){
            if(value && value.txt){ _this.search=value.txt??null; }
            else{ _this.search=null; }
        });
        if((selected_item??false) && (selected_item.txt??false)){
            this.search=this.selected_item.txt;
        }
        this.updateSearchSummary();
    },
    getItems(){
        this.get_ajax_result();
    },
    selectItem(item){
        this.search=item.txt;
        this.selected_item=item;
        this.open=false;
        this.updateSearchSummary();
    },
    unselectItem(item){
        console.log('unselectItem');
        this.search=null;
        this.selected_item={};
        this.open=false;
        this.updateSearchSummary();
    },
    get_ajax_result() {
        let _this=this;
        if (this.urlAjax) {
            fetch(this.urlAjax +
                    "?limit=" +(this.limit??'') +
                    "&search=" +(this.search ?? "") +
                    "&site_id=" + (this.site_id ?? "")+
                    "&lang=" + (this.lang ?? "")
            ).then((res) => res.json())
            .then((data) => {
                console.log(data);
                this.sourceData = data??[];
                if(Object.keys(this.sourceData).length>0){ this.open=true; }
                else{ this.open=false; }
            });
        }
    },
    updateSearchSummary(){
        window.searchSummary.destination_id = this.site_id;
        //window.searchSummary.destination_label = this.search;
    },
}));

///////////////////////////////////////////
// SWEET ALERT
Livewire.on('loadLivewireAlert', () => {
    import("sweetalert2").then((Swal2) => {
        const Swal = (window.Swal = Swal2.default);
        import(/* webpackChunkName: "livewire-alert" */ "./lib/livewire-alert/livewire-alert.js").then((loadLivewireAlert) => {
            Livewire.emit("loadLivewireAlertIsLoaded");
        });
    });
});


///////////////////////////////////////////
Alpine.data("modal_image", (property_id) => ({
    property_id:property_id,
    loaded:false,
    modal_open:false,
    images:[],
    img_url:null,
    images_count:0,
    img_number:0,
    currentIndex: 1,
    open_modal(index_to_open=0){
        if(this.images_count==0){
            this.load_images(index_to_open);
        }else{
            this.goTo(index_to_open??this.img_number);
            this.loaded=true;
        }
        this.modal_open=true;
    },
    close_modal(){ this.modal_open=false; },
    next() {
        var newval=this.img_number+1;
        if(newval>=this.images_count){ newval=0; }
        this.goTo(newval);
    },
    prev(){
        var newval=this.img_number-1;
        if(newval<0){ newval=this.images_count-1; }
        this.goTo(newval);
    },
    goTo(index) {
        this.img_url=null;
        this.loaded=false;
        this.img_number=index;
        console.log(index);
        this.img_url=this.images[index]['slideshow_1x'];
    },
    load_images(index_to_open){
        var index_to_open=index_to_open??0;
        const url = new URL(cdn_url_img+"/api/property/"+property_id+"/images?model=slideshow_property_page");
        const params = { "sort": "order", };
        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        fetch(url, {  method: "GET", })
        .then((response) => response.json())
        .then((data) => {
            var lazy_images_data=(data.data)
            var temp_images=[];
            for(var i=0;i<lazy_images_data.length;i++){
                var cdn=lazy_images_data[i].cdn;
                var variations=lazy_images_data[i].variations??false;
                if(!variations){ continue; }
                temp_images[i]={'slideshow_1x':''+cdn+variations['slideshow_1x'],'slideshow_2x':''+cdn+variations['slideshow_2x']};
            }
            if(temp_images.length>0){
                this.lazy_images=temp_images;
                this.images_to_render=[this.lazy_images[0], this.lazy_images[1]];
                this.images_count=this.lazy_images.length;
            }
            this.images=temp_images;
            this.goTo(index_to_open);
        });
    }
}));


///////////////////////////////////////////
// SHARE
Alpine.data("share", () => ({
    open_popin(url){
        var url_share=url;
        window.open(url_share, 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
    }
}));

///////////////////////////////////////////
/// LOADER ON SUBMIT BUTTON
if(document.getElementById("submit_search_form")){
    document.getElementById('submit_search_form').addEventListener('click', function() {
        document.getElementById('submit_search_form_loader').style.display = 'inline';
    });
}

///////////////////////////////////////////
// SIMPLE MAP
Alpine.data("gmap", (settings) => ({
    settings: settings,
    thismap: null,
    init_lazy($dispatch) {
        import("./lib/gmap/gmap.js?t=65255").then((e) => {
            const mhiMap = new e.MhiMap();
            mhiMap.initLazy($dispatch, this, this.settings); // Output: "Hello World!"
            mhiMap.createMap();
            this.thismap = mhiMap;
        });
    },
    re_init($dispatch) {
        this.thismap.initLazy($dispatch, this, this.settings);
        this.thismap.createMap();
    },
    zoom_in() { this.thismap.zoom_in(); },
    zoom_out() { this.thismap.zoom_out(); },
}));

// PRICE PICKER
// Alpine.data("pricepicker", (rangeMin, rangeMax, min, max) => ({
//     open:false,
//     range: rangeMax - rangeMin,
//     rangeMin,
//     rangeMax,
//     min,
//     max,
//     dragLeft: false,
//     dragRight: false,
//     handleThumbMouseMove: function(e) {
//         if (!this.dragLeft && !this.dragRight) return;
//         const thumbEl = this.dragLeft ? this.$refs.minThumb : this.$refs.maxThumb;
//         const sliderRect = this.$refs.sliderEl.getBoundingClientRect();
//         let r = (e.clientX - sliderRect.left) / sliderRect.width;
//         r = Math.max(0, Math.min(r, 1));
//         const value = Math.floor(r * this.range + this.rangeMin);
//         if (this.dragLeft) {
//             this.min = value;
//             this.max = Math.max(this.min, this.max);
//         } else {
//             this.max = value;
//             this.min = Math.min(this.min, this.max);
//         }
//     }
// }));

//////////////////////////////////////////////
// RATING STAR
Alpine.data("rating", (rate,count=null) => ({
    rate: rate,
    count: count,
    init_lazy() {
        var html="<ul class=\"float-left  text-color-secondary\">";
        for (let i = 1; i <= 5; i++) {
            let icon = '';
            icon = 'icon-star_outline';
            if (i-0.25 <= rate ) { icon = 'icon-star'; }
            else if ( i-0.75 < rate) { icon = 'icon-star_half'; }
            html += '<li><i class="' + icon + '"></i></li>';
          }

        if(count!=null){
            html+='<li class="count-opinion">('+count+')</li>';
        }
        html+='</ul>';
        this.$el.innerHTML=html;
    },
}));

//////////////////////////////////////////////
// DATEPCIKER
var datepicker_intited=false;
Alpine.data("datepicker", (opt) => ({
    inited: false, visible: false, opt: opt, datepicker_item:null,
    init_lazy($dispatch) {
        var alpine=this;
        alpine.$watch('opt.start_date', function(){ alpine.datepicker_item.set_dates(); });
        alpine.$watch('opt.end_date', function(){ alpine.datepicker_item.set_dates(); });
       // alpine.$watch('opt', function(value, oldValue){  opt.start_date=value.start_date });
        if (!this.inited) {
            import(
                /* webpackChunkName: "datepicker-v4" */ "./lib/datepicker/datepicker.js?t=12331221"
            ).then((datepicker) => {
                this.inited=datepicker;
                alpine.datepicker_item = new datepicker.DatePicker($dispatch, alpine, this.opt);
                alpine.datepicker_item.draw();
            });
        }else{
            alpine.datepicker_item = new this.inited.DatePicker($dispatch, alpine, this.opt);
            alpine.datepicker_item.draw();
          //  datepick_ext=datepicker_item;
        }
        Livewire.on('reservation-form-reset-dates', function(){
            alpine.datepicker_item.reset_dates();
        })

        // update summary
        window.searchDatepicker = this;
        this.updateSearchSummary();
    },
    reset_dates(){
        this.datepicker_item.reset_dates();
    },
    open(){
        // console.log(this.visible);
        this.visible=true;
        // console.log(this.visible);
        // this.datepicker_item.open();
    },
    reload_ajax(){
        this.datepicker_item.reload_ajax_data();
    },
    close() {
        this.visible = false;
        this.$el.classList.remove("datepicker-edit-start");
        this.$el.classList.remove("datepicker-edit-end");
    },
    updateSearchSummary(){
        if(typeof typeof window.searchSummary!=="undefined"){
            window.searchSummary=window.searchSummary??{};
            // console.log(window.searchSummary);
            if(typeof window.searchSummary.date_start!=="undefined"){ window.searchSummary.date_start = this.opt.start_date; }
            if(typeof window.searchSummary.date_end!=="undefined"){ window.searchSummary.date_end = this.opt.end_date; }
        }
    },
}));


//////////////////////////////////////////////
// SEARCH SUMMARY
Alpine.data("searchSummary", () => ({
    modal_is_open: false,
    destination_id: null,
    destination_label: '',
    date_start: null,
    date_start_text: null,
    date_end: null,
    date_end_text: null,
    peoples_count: 0,
    peoples: null,
    init_lazy($dispatch) {
        window.searchSummary = this;
    },
    set_destination_label(label) {
        this.destination_label = label;
    },
    moveNode(source, destination) {
        let dummy = document.createElement('span');
        source.before(dummy);
        destination.before(source);
        dummy.replaceWith(destination);
    },
    openSearchModal(){
        if(document.body.contains(document.getElementById('modalSearchContent'))){
            this.modal_is_open = true;
            this.moveNode(document.getElementById('modalSearchContent'), document.getElementById('formSearchContent'));
            let containerHomeHeader=document.getElementById('container-header-home');
            if(containerHomeHeader) containerHomeHeader.classList.add('container-modal-open');
        }
    },
    closeSearchModal(){
        // HomePage
        if(document.getElementsByClassName('home').length == 1){
            document.getElementsByClassName('form-vertical')[0].submit();
        }
        // Others pages
        if(document.body.contains(document.getElementById('modalSearchContent'))){
            if(this.modal_is_open){
                this.moveNode(document.getElementById('formSearchContent'), document.getElementById('modalSearchContent'));
            }

            this.modal_is_open = false;
            let containerHomeHeader=document.getElementById('container-header-home');
            if(containerHomeHeader) containerHomeHeader.classList.remove('container-modal-open');
        }
    }
}));

//////////////////////////////////////////////
// SEARCH FILTERS MODALS ON MOBILE
Alpine.data("searchFilters", () => ({
    modal_is_open: false,
    init_lazy($dispatch) {
        window.searchFilters = this;
    },
    set_destination_label(label) {
        this.destination_label = label;
    },
    moveNode(source, destination) {
        let dummy = document.createElement('span');
        source.before(dummy);
        destination.before(source);
        dummy.replaceWith(destination);
    },
    openFiltersModal(){
        if(document.querySelector('.modal-filters .os-filters') == null ){
            //console.log('Filters => Move to modal');
            this.moveNode(document.getElementById('modalFiltersContent').children[0], document.getElementById('formFiltersContent').children[0]);
        }
        this.modal_is_open = true;
    },
    closeFiltersModal(){
        if(document.querySelector('.os-results .os-filters') == null ){
            //console.log('Filters => Move to results page');
            this.moveNode(document.getElementById('formFiltersContent').children[0], document.getElementById('modalFiltersContent').children[0]);
        }
        this.modal_is_open = false;
    },
    refreshFiltersModal(){
        if(this.modal_is_open==false){ }else{
            // Move into content for livewire refresh it
            this.moveNode(document.getElementById('formFiltersContent').children[0], document.getElementById('modalFiltersContent').children[0]);
            $('#modalFilters').modal('hide');
            // Wait livewire finish get results
            setTimeout(function(){  window.searchFilters.openFiltersModal(); $('#modalFilters').modal('show'); }, 1000);
        }
    },

}));


//////////////////////////////////////////////
// DATEPCIKER MODAL EDIT
Alpine.data("datepicker_modal_edit", (settings) => ({
    settings: settings,
    wire: settings.wire, open:false,
    init() {
        this.wire.on('datepickerreloadajax', () => {   this.open=false;      this.$dispatch('datepickerresetdates');  this.$dispatch('alpinedatepickerresetdates'); });
    },
    udpate_params(params) {
        if (params.type_update == "dates" &&  params.start_date && params.end_date) {
            this.wire.set_dates(params.start_date, params.end_date);
            this.open=true;
        }
    },
    unselect_dates() {
        this.$dispatch('datepickerresetdates');
        this.wire.set_dates(null, null);
    },
}));


// COUNTER
Alpine.data("counter_debounced", (value,min=0, max=100, event_to_dispatch=null) => ({
    min: min,
    max: max,
    value: value,
    lazyvalue: 0,
    event_to_dispatch: event_to_dispatch,
    init() { this.lazyvalue=this.value; this.check(); window.searchSummary.peoples_count = window.searchSummary.peoples_count + this.lazyvalue; },
    add(value) { this.lazyvalue = parseInt(this.lazyvalue) + value; this.check(); window.searchSummary.peoples_count = window.searchSummary.peoples_count + value; },
    remove(value) { this.lazyvalue = parseInt(this.lazyvalue) - value; this.check(); window.searchSummary.peoples_count = window.searchSummary.peoples_count - value; },
    check() {
        if (this.lazyvalue < this.min) {
            this.lazyvalue = this.min;
        }
        if (this.lazyvalue > this.max) {
            this.lazyvalue = this.max;
        }
        this.value=this.lazyvalue;
        if(this.event_to_dispatch!=null){ this.$dispatch(this.event_to_dispatch); }
    }
}));

Alpine.data("reservation_form", (settings) => ({
    settings: settings,
    wire: settings.wire,
    actual_start_date: null, actual_end_date: null,
    udpate_params(params) {
        if (params.type_update == "dates") {
            if(this.actual_end_date!=params.end_date || this.actual_start_date!=params.start_date){
                this.wire.set("start_date", params.start_date);
                this.wire.set("end_date", params.end_date);
            }
        }
        if (params.type_update == "peoples") {
            this.wire.set("adults_number", params.adults_number);
            this.wire.set("children_number", params.children_number);
            this.wire.set("babies_number", params.babies_number);
        }
        if (params.type_update == "peoples_dates") {
            this.wire.set("adults_number", params.adults_number);
            this.wire.set("children_number", params.children_number);
            this.wire.set("babies_number", params.babies_number);
            this.wire.set("start_date", params.start_date);
            this.wire.set("end_date", params.end_date);
        }
        this.actual_end_date=params.end_date??null;
        this.actual_start_date=params.start_date??null;
    },
}));

window.addEventListener('reservation-form-updated', event => {
    setTimeout(function(){
        $('[data-toggle="tooltip"]').tooltip();
    }, 1000);
})

var glightbox_script = false;
Alpine.data("paletteSlideshow", () => ({
    open_palette: false,
    glightbox_instance:null,
    glightbox_params : { selector: '.glightbox', loop:true, closeOnOutsideClick:true, },
    init() {
        // this.$watch('open', value => {
        //     if (value) {
        //         this.$nextTick(() => {
        //             this.$refs.paletteSlideshow.focus();
        //         });
        //     }
        // });
    },
    openPalette() {
        // ADD no-scroll to body
        document.body.classList.add('no-scroll');
        this.open_palette = true;
    },
    closePalette() {
        this.open_palette = false;
    },
    openImage(index){
        var _this=this;
        if(!glightbox_script || _this.glightbox_instance===null){
            import('glightbox').then((GLightbox) => {
                console.log('glightbox js loaded');
                import("glightbox/dist/css/glightbox.css").then((loader2css) => {
                    console.log('glightbox css loaded');
                    glightbox_script = GLightbox.default;
                    console.log(_this.glightbox_params);
                    _this.glightbox_instance=glightbox_script(_this.glightbox_params);
                    _this.glightbox_instance.openAt(index);
                });
            });
        }else if(_this.glightbox_instance){
            _this.glightbox_instance.openAt(index);
        }
    }
}));


// GET STAY PRICE
var waitlist_price_to_get=[];
Alpine.data("load_stay_price", (properties_ids, start_date, end_date, adults, children) => ({
    properties_ids: properties_ids,
    start_date: start_date,
    end_date: end_date,
    adults: adults,
    children: children,
    prices: [],

    async init() {
        await this.fetchPricesInChunks();
    },

    async fetchPricesInChunks() {
        const chunkSize = 3;
        for (let i = 0; i < this.properties_ids.length; i += chunkSize) {
            const chunk = this.properties_ids.slice(i, i + chunkSize);
            await this.fetchPrices(chunk);
        }
    },

    async fetchPrices(ids) {
        try {
            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            const response = await fetch("/get-stay-price-by-ids", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken
                },
                body: JSON.stringify({
                    properties_ids: ids,
                    start_date: this.start_date,
                    end_date: this.end_date,
                    adults: this.adults,
                    children: this.children,
                }),
            });
            if (response.ok) {
                const data = await response.json();
                this.updatePricesOnPage(data);
            } else {
                console.error("Failed to fetch prices for IDs:", ids);
            }
        } catch (error) {
            console.error("Error fetching prices:", error);
        }
    },
    updatePricesOnPage(prices) {
        for (const [id, priceData] of Object.entries(prices)) {
            const fakePriceElement = document.getElementById(`promo_tenant_final_price_${id}`);
            const priceElement = document.getElementById(`tenant_final_price_${id}`);
            const priceElementContainer = document.getElementById(`container_tenant_final_price_${id}`);
            const oldpriceElementContainer = document.getElementById(`old_container_tenant_final_price_${id}`);
            if (priceElement && priceData.tenant_final_price) {
                if(fakePriceElement && typeof priceData.no_discounted_price!== "undefined" && priceData.no_discounted_price){
                    fakePriceElement.textContent=priceData.no_discounted_price+'€';
                }
                // if(typeof )
                priceElement.textContent = priceData.tenant_final_price+'€';
                // REMOVE DISPLAY NONE ON CONTAINER
                priceElementContainer.style.display = 'block';
                // HIDE OLD PRICE
                if(oldpriceElementContainer){ oldpriceElementContainer.style.display = 'none'; }
            } else {
                console.warn(`Element with ID tenant_final_price_${id} not found`);
            }
        }
    },
}));


Alpine.start();
